/* eslint-disable @typescript-eslint/no-explicit-any */
import { call, put, takeLatest } from 'redux-saga/effects';
import AT from '../constants/action-types';
import { fetchServiceProviders, fetchUserProfile } from '../api';
import { getItem, removeItem, setItem } from '../db';
import run from './helpers/run';
import { reloadProviderData } from './helpers/reload-provider-data';
import * as R from 'ramda';

function setupComplete(...args: any[]) {
  return !R.all((entity: any) => R.isEmpty(entity.data.items), args);
}

/**
 * The super admin (role `admin`) has no provider of its own: it picks one, and
 * the API client names it in `X-Provider-Id`. Keeps the last pick if it still
 * exists, else the first provider. Everyone else gets their token's provider
 * and never stores one.
 */
function* chooseProvider(user: any): any {
  if (!(user.roles ?? []).includes('admin')) {
    yield call(removeItem, 'providerId');
    return;
  }
  const providers = yield call(fetchServiceProviders);
  yield put({ type: AT.FETCH_SERVICE_PROVIDERS_DONE, ...providers });
  const ids = providers.data.items.map((p: any) => p.id);
  const stored = yield call(getItem, 'providerId');
  yield call(setItem, 'providerId', ids.includes(stored) ? stored : ids[0] ?? null);
}

/**
 * Load the signed-in user and their provider's data.
 *
 * Every session loads exactly one provider: the token's, or for the super
 * admin the one it picked (see chooseProvider).
 */
function* appInit() {
  yield run(function* () {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const user = yield call(fetchUserProfile);
    yield put({ type: AT.FETCH_USER_PROFILE_DONE, ...user });
    yield chooseProvider(user.data.user);
    const { services, locations, queues, controlBoxes } =
      yield reloadProviderData();
    // `reloadProviderData` emits APP_INIT_COMPLETED itself, on both the happy
    // and the failed path, so there is nothing left to announce here.
    if (setupComplete(services, locations, queues, controlBoxes)) {
      yield put({ type: AT.SIMPLE_SETUP_COMPLETED });
    }
  });
}

export default function* appInitSaga() {
  yield takeLatest(AT.APP_INIT_SAGA, appInit);
}
